export const unitedStatesStates = [
  {
    locationId: 21132,
    name: 'United States (Alaska)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21133,
    name: 'United States (Alabama)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21135,
    name: 'United States (Arkansas)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21136,
    name: 'United States (Arizona)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21137,
    name: 'United States (California)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21138,
    name: 'United States (Colorado)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21139,
    name: 'United States (Connecticut)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21140,
    name: 'United States (District of Columbia)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21141,
    name: 'United States (Delaware)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21142,
    name: 'United States (Florida)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21143,
    name: 'United States (Georgia)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21144,
    name: 'United States (Hawaii)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21145,
    name: 'United States (Iowa)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21146,
    name: 'United States (Idaho)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21147,
    name: 'United States (Illinois)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21148,
    name: 'United States (Indiana)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21149,
    name: 'United States (Kansas)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21150,
    name: 'United States (Kentucky)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21151,
    name: 'United States (Louisiana)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21152,
    name: 'United States (Massachusetts)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21153,
    name: 'United States (Maryland)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21154,
    name: 'United States (Maine)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21155,
    name: 'United States (Michigan)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21156,
    name: 'United States (Minnesota)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21157,
    name: 'United States (Missouri)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21158,
    name: 'United States (Mississippi)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21159,
    name: 'United States (Montana)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21160,
    name: 'United States (North Carolina)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21161,
    name: 'United States (North Dakota)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21162,
    name: 'United States (Nebraska)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21163,
    name: 'United States (New Hampshire)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21164,
    name: 'United States (New Jersey)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21165,
    name: 'United States (New Mexico)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21166,
    name: 'United States (Nevada)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21167,
    name: 'United States (New York)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21168,
    name: 'United States (Ohio)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21169,
    name: 'United States (Oklahoma)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21170,
    name: 'United States (Oregon)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21171,
    name: 'United States (Pennsylvania)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21172,
    name: 'United States (Rhode Island)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21173,
    name: 'United States (South Carolina)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21174,
    name: 'United States (South Dakota)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21175,
    name: 'United States (Tennessee)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21176,
    name: 'United States (Texas)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21177,
    name: 'United States (Utah)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21178,
    name: 'United States (Virginia)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21179,
    name: 'United States (Vermont)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21180,
    name: 'United States (Washington)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21182,
    name: 'United States (Wisconsin)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21183,
    name: 'United States (West Virginia)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    locationId: 21184,
    name: 'United States (Wyoming)',
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  }
];
